import React from "react";
import { FaTwitter, FaLinkedin, FaAngellist, FaGithub } from "react-icons/fa";

const About = () => {
  const socials = [
    {
      link:"https://twitter.com/devaladdin",
      name: "Twiter",
      logo: <FaTwitter />
    },
    {
      link:"https://www.linkedin.com/in/inaolaji-taofeek-64587b169",
      name: "Linkedin",
      logo: <FaLinkedin />
    },
    {
      link:"https://angel.co/u/taofeek-akinkunmi",
      name: "Wellfound",
      logo: <FaAngellist />
    },
    {
      link:"https://github.com/aladdin4u",
      name: "Github",
      logo: <FaGithub />
    },
  ]
  return (
    <div
      className="py-[64px] bg-black bg-gradient-to-b from-zinc-900 via-zinc-400/10 to-zinc-900"
      id="about"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto my-0 justify-center items-center">
        <div className="text-justify text-md text-zinc-300 px-6 space-y-2">
          <h3 className="text-2xl text-md font-bold text-zinc-100 mb-4 uppercase">
            About me
          </h3>
          <p>
            Taofeek Inaolaji is a software engineer. Who takes complex technical
            problems or ideas and distills them into user-friendly visuals to
            improve digital marketing campaigns for companies. He has an
            education in traditional advertising and a background loaded of
            marketing and graphic design projects, centered around modernizing
            the consumer expericence.
          </p>
        </div>
        <div className="flex flex-col items-center">
          <img
            src="images/about_me.png"
            alt="Taofeek Inaolaji"
            className="w-48 h-auto rounded-full mx-auto border-8 border-indigo-500"
          />
          <div className="flex space-x-1 my-4">
            {socials &&
              socials.map((social) => (
                <a
                  key={social.link}
                  href={social.link}
                  target="_blank"
                  aria-label={social.name}
                  rel="noopener"
                  className="text-zinc-400 hover:bg-zinc-800 hover:text-zinc-300 px-3 py-2 rounded-md text-sm font-medium"
                >
                  {social.logo}
                </a>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
